
import {theme} from "../../utils";

export const marginBottom = "29px";

export const homeStyles = {
    cardHeading:{
        width:"100%",
        borderTopLeftRadius: '24px',
        borderTopRightRadius: '24px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        height: '4.5rem'
    },
    cardHeadingText: {
        ...theme.typography.poppinsBodyMedium,
        fontSize: '16px',
        color:'black',
        my:'5px',
        lineHeight: '100%',
        LetterSpacing:'0%',
    },
    rowAlignBtnWrapper: {
        color: "#000",
        width: "128px",
        height: "38.33px",
        textTransform: "capitalize",
        borderRadius: '8px'
    },
    descriptionBox: {
        backgroundColor: "#F8F8F8",
        pb: "27px",
        pt: "1rem",
    },
    bulletList: {
        textAlign: "left",
        marginBottom: marginBottom,
    },
    listItem: {
        ...theme.typography.poppinsBodyRegular,
        fontSize: '22px',
        lineHeight: '30px',
        marginBottom: marginBottom
    },
}

export const tabStyles = {
    tabContainer: {
        marginTop:"-36px"
    },
    tab: {
        ...theme.typography.poppinsBodyRegular,
        width: '100%',
        height: '53px',
        textTransform: "none",
        fontWeight: 500,
        fontSize: "1rem",
        borderTopLeftRadius: "24px",
        borderTopRightRadius: "24px",
        display: "flex",
        maxWidth: "unset",
        cursor:'default',

    },
    educationHubTab:{
        backgroundColor: "#4B69F1",
        color: '#FFFFFF',
        '&.Mui-selected': {
            color: '#FFFFFF',
        },
    },
    aiToolsTab:{
        backgroundColor: "#BBC2CF",
        color: '#1E1E22F',
        '&.Mui-selected': {
            color: '#1E1E22',
        },
    }
}


export interface IAIToolsProps {
    data: any[]
}

export const sortVendorData = (data: any[]) => {
    if (data.length) {
        const sortedData = data.sort((a, b) => {
            const vendorA = a?.title?.toUpperCase();
            const vendorB = b?.title?.toUpperCase();

            return vendorA.localeCompare(vendorB);
        });
        return sortedData
    }
    return []
}